import { Horse_show } from './horse_show';
import { Horse_show_entry } from './horse_show_entry';
import { Sms_order } from './sms_order';
import { Braintree_transaction } from './accounting/banking/braintree_transaction';
import { User } from './user';

export class Follow_up_payment_receipt {
	order_id: string;
	order_map: Sms_order[];
	horse_show: Horse_show;
	transactions: Braintree_transaction[];
	horse_show_entry_list: Horse_show_entry[];
	user: User;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}